import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { Observable, of, Subscription } from "rxjs";
import { EnumModoSelecao } from "src/app/enums/EnumModoSelecao";
import { OpcaoToolbar } from "src/app/models/opcaoToolbar";
import { SelectionTexto } from "src/app/models/SelectionTexto";
import { ConfiguracoesUsuario } from "src/app/models/usuario/ConfiguracoesUsuario";
import { ButtonSheetService } from "src/app/services/button-sheet.service";
import { UsuarioPreferenciasService } from "src/app/services/data-services/usuario.preferencias.service";
import { SelectionService } from "src/app/services/selection.service";
import { UiService } from "src/app/services/ui.service";

@Component({
  selector: "app-leitor-side-menu-mobile",
  templateUrl: "./leitor-side-menu-mobile.component.html",
  styleUrls: ["./leitor-side-menu-mobile.component.scss"],
})
export class LeitorSideMenuMobileComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private _bottomSheet: MatBottomSheet,
    private buttonSheetService: ButtonSheetService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.buttonSheetService
        .getOpenButtonSheet()
        .subscribe((open) => this.toggleOpenBottomSheet(open))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  toggleOpenBottomSheet(open: boolean): void {
    if (open) {
      this._bottomSheet.open(LeitorSideMenuMobileSheetComponent, {
        panelClass: "custom-background-leitor-side-menu",
        hasBackdrop: false,
      });
    }
  }
}

@Component({
  selector: "app-leitor-side-menu-mobile-sheet",
  templateUrl: "./leitor-side-menu-mobile-sheet.component.html",
  styleUrls: ["./leitor-side-menu-mobile.component.scss"],
})
export class LeitorSideMenuMobileSheetComponent implements OnInit, OnDestroy {
  public opcoes: OpcaoToolbar[];
  public opcoesExibir: OpcaoToolbar[];
  public opcaoSelecionada: OpcaoToolbar;
  public selection: SelectionTexto = new SelectionTexto();
  public painelBuscaAberto = false;
  public breakpointLg$: Observable<boolean> = of(false);
  public modoSelecao: boolean;
  public ferramentaSelecao = new OpcaoToolbar();
  public textoSidemobile = "";
  public textareAtivo = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<LeitorSideMenuMobileSheetComponent>,
    private selectionService: SelectionService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    public uiService: UiService,
    private buttonSheetService: ButtonSheetService
  ) {}

  closerSheet(): void {
    this._bottomSheetRef.dismiss();
  }

  ngOnInit() {
    this.ferramentaSelecao.descricao = "Modo de seleção";
    this.ferramentaSelecao.modo = EnumModoSelecao.Padrao;
    this.ferramentaSelecao.tipo = null;
    this.ferramentaSelecao.icone = "arrow-pointer";
    this.ferramentaSelecao.ativo = false;
    this.ferramentaSelecao.cor = "#525F7A";

    this.subscriptions.push(
      this.usuarioPreferenciasService
        .getConfiguracoes()
        .subscribe((config) => this.configSubscribe(config))
    );

    this.subscriptions.push(
      this.selectionService.getSelection().subscribe((s) => {
        this.modoSelecao = s.modo === EnumModoSelecao.Padrao;
        this.selection = s;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  public toggle(opcao: OpcaoToolbar): void {
    this.opcaoSelecionada.ativo = false;
    if (opcao === this.opcaoSelecionada) {
      this.opcaoSelecionada = this.ferramentaSelecao;
    } else {
      this.opcaoSelecionada = opcao;
    }
    this.opcaoSelecionada.ativo = true;

    this.selection.modo = this.opcaoSelecionada.modo;
    this.selection.tipo = this.opcaoSelecionada.tipo;

    this.selection.texto = this.textoSidemobile;

    this.selectionService.atualizar(this.selection);
  }

  public setText() {
    this.selection.texto = this.textoSidemobile;

    this.selectionService.atualizar(this.selection);
  }

  public buttonFalse() {
    this.buttonSheetService.atualizaSalvaButtonSheet(false);
    this.buttonSheetService.atualizaOpenButtonSheet(false);
    this.closerSheet();
  }
  public buttonTrue() {
    this.buttonSheetService.atualizaSalvaButtonSheet(true);
    this.buttonSheetService.atualizaOpenButtonSheet(false);
    this.closerSheet();
  }

  private configSubscribe(config: ConfiguracoesUsuario) {
    if (config) {
      this.opcoes = OpcaoToolbar.carregarItensMenu(config.parametrosCaneta);
      // .filter((o) => o.toolbar);
      // this.opcoesExibir = this.opcoes.filter(o => o.descricao !== 'Seleção');
      this.opcoesExibir = this.opcoes;

      if (!this.opcaoSelecionada) {
        this.opcaoSelecionada = this.ferramentaSelecao;
        this.opcaoSelecionada.ativo = true;

        this.selection.modo = this.opcaoSelecionada.modo;
        this.selection.tipo = this.opcaoSelecionada.tipo;

        this.selectionService.atualizar(this.selection);
      } else {
        const opcao = this.opcoes.find(
          (o) =>
            o.modo === this.opcaoSelecionada.modo &&
            o.tipo === this.opcaoSelecionada.tipo
        );

        this.opcaoSelecionada = opcao ?? this.ferramentaSelecao;
      }
    }
  }

  textareChange($event: FocusEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.textareAtivo = !this.textareAtivo;
  }
}
